/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/styles';
import GenericSkeleton from '../../GraphqlSkeletonComponents/GenericSkeleton';

const useStyles = makeStyles({
    container: {
        textAlign: 'center',
        '& #section_id': {
            width: '35px',
            margin: 'auto',
            padding: '5px',
            fontWeight: '700',
            borderRadius: '20px',
            border: '1px solid black',
        },
        '& #section_heading': {
            margin: '10px auto',
        },
        '& #section_subHeading': {
            width: '98%',
            maxWidth: '900px',
            margin: 'auto',
        },
    },
});

const HeaderGenericLoader = () => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div id="section_id">1</div>
            <div id="section_heading"><GenericSkeleton height="30px" width="300px" /></div>
            <div id="section_subHeading">
                <GenericSkeleton height="10px" width="100%" />
                <GenericSkeleton height="10px" width="100%" />
                <GenericSkeleton height="10px" width="100%" />
            </div>
        </div>
    );
};

export default HeaderGenericLoader;
